<template>
  <div>
    <ButtonSekouFilter />
    <SekouMenuKeywordSearch class="mb-8" />

    <SekouMenuFilterOpen class="mb-8" />
    <div class="hidden pc:block">
      <p class="text-lg font-bold px-2">タグから選ぶ</p>
      <SekouMenuAttrs class="mb-8" />
      <p class="text-lg font-bold px-2">エリアから選ぶ</p>
      <SekouMenuArea />
    </div>
  </div>
</template>
